<template>
  <div class="checkbox-container">
    <div class="checkbox-input-container" :style="[{ height: (height-1)+'px', 'min-width': (width-1)+'px' }]" @click="disabled ? null : $emit('update-value')">
      <input
        type="checkbox"
        class="checkbox-default-styling"
        :class="{ disabled: disabled, checked: value }"
        :style="[{ height: height+'px', width: width+'px', border: border }, checkboxStyle]"
        :value="value"
        :key="label"
      >
      <img
        v-if="value === true && indeterminate === false"
        class="check-logo"
        :style="[checkboxIconStyle]"
        src="../../assets/check-bold.png"
        alt="checked"
      >

      <img
        v-if="value === true && indeterminate === true"
        class="check-logo"
        :style="[checkboxIconStyle]"
        src="../../assets/indeterminate.png"
        alt="checked"
      >
    </div>
    <label for="" class="checkbox-label v-label" :style="checkboxLabelStyle">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: "CustomCheckbox",

  props: {
    value: {
      required: true,
    },

    label: {
      default: String,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    height: {
      type: Number,
      default: 13,
    },

    width: {
      type: Number,
      default: 13,
    },

    border: {
      type: String,
    },

    checkboxIcon: {
      type: String,
      default: "mdi-checkbox-marked",
    },

    labelSize: {
      type: Number,
      default: 10,
    },

    indeterminate: {
      type: Boolean,
      default: false
    },

    checkboxStyle: {
      type: Object,
    },

    checkboxIconStyle: {
      type: Object,
      default: () => {
        return {
          'height': (this.height-1)+'px',
          'min-width': (this.width-1)+'px',
        }
      },
    },

    checkboxLabelStyle: {
      type: Object,
      default: () => {
        return {
          'font-size': '10px'
        }
      },
    },
  },

}
</script>

<style scoped>
[type=checkbox] {
  color: var(--app-primary-base);
  vertical-align: middle;
  appearance: none;
  -webkit-appearance: none;
  background: none;
  border: 1px solid var(--app-primary-base);
  outline: 0;
  flex-grow: 0;
  border-radius: 4px;
  background-color: #FFFFFF;
  transition: 50ms;
  cursor: pointer;
  margin: 0;
}

[type=checkbox]:checked {
  background-color: transparent;
}

[type=checkbox].checked {
  background-color: var(--app-primary-base);
}

[type=checkbox].disabled {
  background-color: var(--app-primary-tint-500);
  opacity: 0.84;
  border: none;
  cursor: not-allowed;
}

.checkbox-default-styling {
  position: absolute;
}

.checkbox-input-container {
  margin-right: 5px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.checkbox-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.check-logo {
  cursor: pointer;
  position: absolute;
  z-index: 150;
  transition: 50ms;
}

.checkbox-label {
  color: #767676;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/_Atoms/CustomCheckbox.vue